module.exports = __webpack_public_path__ + "static/media/logo_siv.5ebea643.png";